/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Card_TitleInputs */

const vi_customer_debt_card_title = /** @type {(inputs: Customer_Debt_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công nợ`)
};

/**

* @param {Customer_Debt_Card_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_card_title = /** @type {((inputs?: Customer_Debt_Card_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Card_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_card_title(inputs)
});